import React, { Component } from 'react';
import {
    HashRouter as Router,
    Route
} from 'react-router-dom';

import Application from '../components/application.jsx'
import Activate from '../components/register/navactivate.jsx'
import ResetQuestion from '../components/resetsecretq/resetquestion.jsx'
import DashBoard from '../components/dashboard/dashboard.jsx'

import CardSummary from '../components/cardsummary/summary.jsx'
import CardActivity from '../components/cardsummary/activity.jsx'

import FriendsAndFamily from '../components/friends/friends.jsx'
import TransferHistory from '../components/transferfunds/transferhistory.jsx'
import ShareFunds from '../components/transferfunds/sharefunds.jsx'
// import TransferHistory from '../components/transferfunds/transferhistory.jsx'

import ForgotUserId from '../components/forgotuserId/forgotUserId.jsx'
import ForgotPassword from '../components/forgotpassword/forgotPassword.jsx'
import MyProfile from '../components/myprofile/myprofile.jsx'

import UpgradeMyCard from '../components/upgrademygrade/upgrademycard.jsx'
import NavContact from '../components/navcontact/navcontact.jsx'
import NavFaqs from '../components/authpages/faqs.jsx'
import ViewTransferHistory from '../components/transferfunds/viewtransferhistory.jsx'
import ICoupons from '../components/additionalservices/icoupons.jsx'
import BlockCard from '../components/additionalservices/blockcards.jsx'
import ChangePassword from '../components/navchangepassword/navchangepassword.jsx'
import ChangePin from '../components/navchangepin/navchangepin.jsx'
import TermAndCondition from '../components/authpages/termscondn.jsx'
import SecurityAwareness from '../components/authpages/security.jsx'
import Privacy from '../components/authpages/privacy.jsx'
import Notices from '../components/authpages/notices.jsx'
import PDS from '../components/authpages/pds.jsx'
import Signin from '../components/register/signin.jsx'
import MobFAQS from '../components/mobilefaqs/mobfaq.jsx'
import MobTermAndCondition from '../components/mobileterms/mobiletermsncondition.jsx'
import MobSecurityAwareness from '../components/mobsecurityawareness/mobsecurityawareness.jsx'
import MobPrivacyPolicy from '../components/mobprivacypolicy/mobprivacypolicy.jsx'
import ForceChangePassword from '../components/forcechangepassword/forcechangepassword.jsx'
import ForceChangesecretque from '../components/forcesecretPassword/forcesecretPassword.jsx'
import AuthContactUs from '../components/contactus/authcontactus.jsx'
import '../stylesheet/footer.css'
import LoadCard from '../components/loadcard/loadcard.jsx'
import SubFooter from '../components/subfooter/subfooter.jsx'
import Footer from '../components/footer/footer.jsx'
import SessionOut from '../components/sessionout/sessionout.jsx'
import CardSearch from '../components/adminuser/cardsearch.jsx'
import CardDetails from '../components/adminuser/carddetails.jsx'
import UserIdDetails from '../components/adminuser/useriddetails.jsx'
import MobileNoDetails from '../components/adminuser/mobnodetails.jsx'
import $ from 'jquery'

class Routes extends Component {
    
    render() {
        // console.log("helllooo"+process.env.PUBLIC_URL)
        return (
            <Router>
                <div>
                    <Route exact path="/" component={Application} />
                    <Route exact path="/cardsearch" component={CardSearch} />
                    <Route exact path="/carddetails" component={CardDetails} />
                    <Route exact path="/useriddetails" component={UserIdDetails} />
                    <Route exact path="/mobnodetails" component={MobileNoDetails} />
                    <Route path="/activate-card" component={Activate} />
                    <Route path="/resetquestion" component={ResetQuestion} />
                    <Route path="/home" component={DashBoard} />
                    <Route path="/logout" component={Application} />
                    <Route path="/forgotuserid" component={ForgotUserId} />
                    <Route path="/forgotpassword" component={ForgotPassword} />
                    <Route path="/mobfaqs" component={MobFAQS} />
                    <Route path="/mobtermsandcondition" component={MobTermAndCondition} />
                    <Route path="/mobsecurityawareness" component={MobSecurityAwareness} />
                    <Route path="/mobprivacypolicy" component={MobPrivacyPolicy} />
                    <Route path="/fchangepassword" component={ForceChangePassword} />
                    <Route path="/ForceChangesecretque" component={ForceChangesecretque} />
                    

                    {/* <Route exact path="/my-cards" component={CardSummary} /> */}
                    <Route path="/card-summary" component={CardSummary} />
                    <Route path="/card-activity" component={CardActivity} />
                    <Route path="/signin" component={Signin} />
                    <Route path="/sessionout" component={SessionOut} />

                    {/* <Route exact path="/transfer-funds" component={TransferHistory} /> */}
                    <Route path="/friends&family" component={FriendsAndFamily} />
                    <Route path="/transfer-history" component={TransferHistory} />
                    <Route path="/share-funds" component={ShareFunds} />
                    <Route path="/viewtransfer_history" component={ViewTransferHistory} />

                    {/* <Route exact path="/additional-services" component={MyProfile} /> */}
                    <Route path="/i-coupons" component={ICoupons} />
                    <Route path="/block-card" component={BlockCard} />
                    <Route path="/manage-my-profile" component={MyProfile} />
                    <Route path="/change-password" component={ChangePassword} />
                    <Route path="/change-pin" component={ChangePin} />

                    <Route path="/my-profile/:id" component={MyProfile} />
                    <Route path="/upgrade-my-card" component={UpgradeMyCard} />
                    <Route path="/contact-us" component={NavContact} />
                    <Route path="/authcontact-us" component={AuthContactUs} />

                    <Route path="/faqs" component={NavFaqs} />
                    <Route path="/terms-&-conditions" component={TermAndCondition} />
                    <Route path="/privacy-policy" component={Privacy} />
                    <Route path="/Notices" component={Notices} />
                    <Route path="/PDS" component={PDS} />
                    
                    <Route path="/security-awareness" component={SecurityAwareness} />
                    <Route path="/loadcard" component={LoadCard}/>


                    <SubFooter />
                    <Footer />

                </div>
            </Router >
        );
    }
}

export default Routes;



// WEBPACK FOOTER //
// ./src/routes/routes.jsx